/**
 * @generated SignedSource<<a427ec9fe67bac5c92b9bf555c72be19>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamHeaderProfileButton_employee$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee">;
  readonly " $fragmentType": "TeamHeaderProfileButton_employee";
};
export type TeamHeaderProfileButton_employee$key = {
  readonly " $data"?: TeamHeaderProfileButton_employee$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamHeaderProfileButton_employee">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamHeaderProfileButton_employee",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Avatar_employee"
    }
  ],
  "type": "Employee",
  "abstractKey": null
};

(node as any).hash = "abe1e8a50681767782a0bc625759a92a";

export default node;
